import { Card, Spin, Table } from "antd";
import {
  useGetResearchProject,
  useGetResearchProjectBudget,
} from "../../query/ReseachQuery";

interface ProjectBudgetTabProps {
  alias: string;
}

const ProjectBudgetTab = ({ alias }: ProjectBudgetTabProps) => {
  const { data: project, isLoading: isLoadingProject } =
    useGetResearchProject(alias);
  const { data, isLoading } = useGetResearchProjectBudget(project?.id || 0);
  if (isLoading || isLoadingProject)
    return (
      <div className="flex justify-center items-center h-screen">
        <Spin size="large" />
      </div>
    );
  return (
    <div className="space-y-4">
      <Card title="Tổng hợp ngân sách" size="small">
        <Table
          columns={[
            {
              title: "Nội dung",
              dataIndex: "categoryName",
              key: "categoryName",
              width: 250,
            },
            {
              title: "Tổng dự toán",
              dataIndex: "budgetedAmount",
              key: "budgetedAmount",
              align: "right",
              render: (value) => Number(value).toLocaleString("vi-VN"),
            },
            {
              title: "Đã chi",
              dataIndex: "spentAmount",
              key: "spentAmount",
              align: "right",
              render: (value) => Number(value).toLocaleString("vi-VN"),
            },
            {
              title: "Còn lại",
              key: "remaining",
              align: "right",
              render: (_, record) => {
                const remaining =
                  Number(record.budgetedAmount) - Number(record.spentAmount);
                return (
                  <span
                    style={{
                      color: remaining > 0 ? "#52c41a" : "#ff4d4f",
                    }}
                  >
                    {remaining.toLocaleString("vi-VN")}
                  </span>
                );
              },
            },
          ]}
          dataSource={data?.projectBudgetCategories}
          pagination={false}
          size="small"
          summary={() => {
            const totalBudgeted =
              data?.projectBudgetCategories?.reduce(
                (sum, item) => sum + Number(item.budgetedAmount),
                0,
              ) || 0;
            const totalSpent =
              data?.projectBudgetCategories?.reduce(
                (sum, item) => sum + Number(item.spentAmount),
                0,
              ) || 0;
            const totalRemaining = totalBudgeted - totalSpent;

            return (
              <Table.Summary.Row className="font-semibold">
                <Table.Summary.Cell index={0}>Tổng cộng</Table.Summary.Cell>
                <Table.Summary.Cell index={1} align="right">
                  {totalBudgeted.toLocaleString("vi-VN")}
                </Table.Summary.Cell>
                <Table.Summary.Cell index={2} align="right">
                  {totalSpent.toLocaleString("vi-VN")}
                </Table.Summary.Cell>
                <Table.Summary.Cell index={3} align="right">
                  <span
                    style={{
                      color: totalRemaining > 0 ? "#52c41a" : "#ff4d4f",
                    }}
                  >
                    {totalRemaining.toLocaleString("vi-VN")}
                  </span>
                </Table.Summary.Cell>
              </Table.Summary.Row>
            );
          }}
        />
      </Card>
    </div>
  );
};

export default ProjectBudgetTab;
